<template>
  <v-form ref="form" v-model="valid" @submit.prevent="confirm">
    <!-- TEXT -->
    <div v-if="field.dataType == 'Text'">
      <v-text-field
        v-model="model"
        :label="field.label"
        type="text"
        clearable
        :rules="field.isRequired ?$isRequiredRule : [] "
      />
    </div>

    <!-- NUMERIC -->
    <div v-if="field.dataType == 'Numeric'">
      <v-text-field
        v-model="model"
        :label="field.label"
        type="number"
        clearable
        :rules="field.isRequired ?$isRequiredRule : [] "
      />
    </div>

    <!-- COMBO -->
    <div v-if="field.dataType == 'Combo'">
      <v-select
        v-model="model"
        :label="field.label"
        :items="field.combo"
        clearable
        :rules="field.isRequired ?$isRequiredRule : [] "
      ></v-select>
    </div>

    <!-- DATE -->
    <div v-if="field.dataType == 'Date'">
      <datetime-picker-dialog
        dateFormat="dd/MM/yy"
        :label="field.label"
        v-model="model"
        :rules="field.isRequired ?$isRequiredRule : [] "
      ></datetime-picker-dialog>
    </div>
  </v-form>
</template>

<script>
import formValidationMixin from '../../../mixins/formValidationMixin'
export default {
    name:'action-field-auto-form',
    props:['field', 'confirm'],
    mixins:[formValidationMixin],
    data(){
        return{
            model:null,
            valid:true
        }
    },
    watch:{
      value(){
        this.model = this.value
      }
    },
    methods:{
        getValue(){
            return { field:this.field.label, value: this.model };
        },
        clear(){
          this.model = null;
          this.resetValidation();
        }
    },
    mounted(){
        this.model = this.value;
    }

}
</script>

<style>

</style>